import { IRoute } from "@src/routes";
import ListProductPage from "./pages/ListProductPage";
import ViewProductPage from "./pages/ViewProductPage";
import { SsoRolesEnum } from "@funcional/react-auth-ui";


const routes: IRoute[] = [
  // {
  //   menu: { label: "Novo Produto" },
  //   path: "/pbm/products/new",
  //   key: "PBM_PRODUCT_CREATE",
  //   exact: true,
  //   roles: [
  //     SsoRolesEnum.MASTER,
  //     SsoRolesEnum.SUPPORT,
  //     SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
  //   ],
  //   component: CreateProductPage,
  // },
  // {
  //   path: "/pbm/products/:ean/edit",
  //   key: "PBM_PRODUCT_EDIT",
  //   exact: true,
  //   roles: [
  //     SsoRolesEnum.MASTER,
  //     SsoRolesEnum.SUPPORT,
  //     SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
  //   ],
  //   component: EditProductPage,
  // },
  {
    path: "/pbm/products/:ean",
    key: "PBM_PRODUCT_VIEW",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ViewProductPage,
  },
  {
    menu: {
      label: "Produtos",
    },
    path: "/pbm/products",
    key: "PBM_PRODUCT_LIST",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListProductPage,
  },
];

export default routes;
